<template>
	<div :class="classNames">
		<div :class="classNames+ '_search'">
			<el-button type="primary" @click="createMarket">添加关联商品</el-button>
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'">
					<el-input placeholder="请输入课程标题" v-model="searchObj.product_name" class="input-with-select">
						<el-button slot="append" type="primary"  @click="search">查询</el-button>
					</el-input>
					
				</div>
			</div>
		</div>
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="marketList.list"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
							<template v-if="item.prop === 'shop'">
								<div :class="classNames+ '_table_imgtitle'">
                                    <img :src="scope.row.goods_img"/>
									<div>
										<p>{{scope.row.goods_name}}</p>
										<p>是否购买后展示：{{scope.row.is_buy == 1 ? '否': '是'}}</p>
									</div>
                                </div>
							</template>
							<div v-else>{{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<span @click="deltes(scope.row)" :class="classNames+'_operation_title'">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="marketList.total" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(marketList.total / searchObj.limit) > 1"></Pagination>
		</div>
	</div>
</template>

<script>
	import {
		data
	} from './data.js'
	// import { common } from '@/pages/mixin/common.js'
	import {
		mapState,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	export default {
		name: 'Relation',
		mixins: [data],
		data() {
			return {
				classNames: 'relation',
				searchObj: {
					product_name: '',
					page: 1,
					limit: 10
				},
                marketList: {
                    list: [],
                    total: 0
                },
				noDataName: 'empty'
			}
		},
		created() {
			this.getActiveList()
		},
		components: {
			Pagination
		},
		computed: {
			...mapState(['breadCrumbList'])
		},
		methods: {
			...mapActions('relation', ['relationList', 'relationRemove']),
            changeSize(value) {
                this.searchObj.page = value
                this.getActiveList()
            },
            handleBreadCrumb(path, name, id, index = 2) {
				let breadCrumbList = this.breadCrumbList
				breadCrumbList[index] = {
					title: name,
					path: id ? path + '/' + id : path
				}
				localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
				this.$router.push({
					path: id ? path + '/' + id : path,
				})
				breadCrumbList[index] = {
					title: name,
					path: this.$route.fullPath
				}
			},
            createMarket() {
                this.handleBreadCrumb('/createRelation', '添加商品')
            },
            deltes(row) {
                this.$confirm('确定要删除吗？', '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					try {
                        await this.relationRemove({id: row.id})
                        this.getActiveList()
                        this.$message(
                            {
                                type: 'success',
                                message: '删除成功',
                                duration: 3000
                            }
                        )
                    } catch (error) {
                        
                    }
				})
            },
            async getActiveList() {
                let res = await this.relationList(this.searchObj)
                this.marketList = {
                    list: res.data,
                    total: res.count
                }
            },
            search() {
				this.noDataName = 'noData'
                this.searchObj.page = 1
                this.getActiveList()
            }
		},
		watch: {
			searchObj: {
				deep: true,
				handler(news) {
					// this.getClassLists(news)
				}
			}
		}
	}
</script>
<style lang="less">
	@classNames: relation;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search_btn {
			width: 70px;
			height: 40px;
			background: #1989FA;
			border-radius: 0px 2px 2px 0px;
			color: #FFFFFF;
			font-size: 14px;
		}
		.@{classNames}_operation_title {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
			// &:not(:last-child) {
			// 	margin-right: 12px;
			// }

		}
		.@{classNames}_table_imgtitle {
			display: flex;
			align-items: flex-start;
			img {
				width: 67px;
				height: 50px;
				margin-right: 10px;
			}
			
		}
		.@{classNames}_search_con_item {
			.el-input-group__append {
				background: #1989FA;
				color: #fff;
			}
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_common_dialog {
		padding: 30px;
		width: 360px;
		box-sizing: border-box;
		.el-message-box__header {
			padding: 0;
		}
		.el-message-box__headerbtn {
			top: 0;
			right: 0;
		}
		.el-message-box__content {
			padding: 0;
			.el-message-box__message {
				padding-top: 12px;
				padding-bottom: 16px;
			}
		}
		.el-message-box__btns {
			.el-button {
				width: 77px;
				height: 28px;
				padding: 0;
				text-align: center;
				line-height: 28px;
			}
		}
	}
</style>
<style lang='less' scoped>
	@classNames: relation;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;

		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}

		.@{classNames}_con {	
			display: flex;
			flex-direction: column;
			flex: 1;
		}
	}
</style>
